module.exports = __webpack_public_path__ + "static/media/cloud_connector_modal.8ef23e39.png";